/**
 * export — part of the German catalogue (the reference language).
 * Merged in `i18n/de.ts`; every key here must exist in `i18n/en/export.ts`.
 */

export const exportKeys = {
  /* ---------------- das Formblatt als PDF ---------------- */
  'export.pdf.title': 'LBA-Formblatt als PDF',
  'export.pdf.line': 'Das ausgefüllte Original-Formblatt – genau wie im Formular.',
  'export.pdf.info':
    'Das PDF ist das Dokument, das ins Knieboard gehört, und es lässt sich aus dem Browser heraus drucken. Der Ausdruck dieser Seite ist kein Formblatt.',
  'export.pdf.btn': 'PDF herunterladen',
  'export.pdf.busy': 'PDF wird erzeugt …',
  'export.pdf.preview': 'Vorschau',
  'export.pdf.err': 'PDF konnte nicht erzeugt werden.',
  'export.pdf.complete': 'Alle wichtigen Felder sind ausgefüllt.',
  'export.pdf.missing': 'Noch offen: {list}',
  'export.pdf.missing.more': 'Noch offen: {list} · +{n} weitere',

  /* ---------------- der Freigabe-Link ---------------- */
  'export.share.title': 'Link teilen',
  'export.share.line': 'Wer den Link hat, sieht den Flug – ohne Konto, ohne Änderungen.',
  'export.share.btn': 'Link erstellen',
  'export.share.busy': 'Link wird erstellt …',
  'export.share.copied': 'kopiert',
  'export.share.local':
    'Dieser Flug liegt nur in diesem Browser. Nach dem Anmelden lässt er sich teilen.',

  /* ---------------- die Datei ---------------- */
  'export.file.title': 'Datei',
  'export.file.line': 'Alle Werte als Datei sichern – oder eine Datei einlesen und weiterplanen.',

  /* ---------------- was noch kommt ---------------- */
  'export.soon.title': 'Weitere Vorlagen',
  'export.soon.line': 'In Arbeit – kommt in einer der nächsten Fassungen.',
  'export.soon.navlog': 'Navigationslog als PDF',
  'export.soon.fpl': 'ICAO-Flugplan',
  'export.soon.wx': 'Wetterunterlagen als PDF',
} as const;
